// import * as types from '@store/mutation-types'

// initial state
// shape: [{ id, quantity }]

const state = {
  options: {
    showInStatistics: [
      {label: '不显示', value: '0'},
      {label: '显示', value: '1'},
    ],
    customerRelationshipType: [
      {label: '无', value: '0'},
      {label: '首次合作', value: '1'},
      {label: '常规客户', value: '2'},
      {label: '潜在客户', value: '3'},
    ],
  },
  selectedCustomer: null,
  selectedCustomerDetail: null,
  types: [
    10, // 大客户
    20, // 查理宝客户
    30, // 星火客户
    40, // 标注客户
    50, // TEKE客户
    60, // 健臻客户
    70, // 爱绩效客户
  ],
}

// getters
const getters = {
  // user: state => state.user
}

// actions
const actions = {
  getCustomerTable ({commit}, params) {
    let promised = request.alert('getCustomerTable', params)
    return promised
  },
  getCustomerDetail ({commit}, params) {
    let promised = request.alert('getCustomerDetail', params)
    return promised
  },
}

// mutations
const mutations = {
  SELECTED_CUSTOMER (state, data) {
    state.selectedCustomer = data
  },
  SELECTED_CUSTOMER_DETAIL (state, data) {
    state.selectedCustomerDetail = data
  }
}

export const customer = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/customer/customer.store.js